import { render, staticRenderFns } from "./SendFileDialog.vue?vue&type=template&id=73b8d951&"
import script from "./SendFileDialog.vue?vue&type=script&lang=js&"
export * from "./SendFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports